import { Icon } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

import type { IconName } from "@/components/icons/Icon";

const BADGE_VARIANTS = {
  invite: { icon: "PlusLarge" },
  comment: { icon: "Comment" },
  request: { icon: "EnterDoor" },
  shared: {
    icon: "Upload",
    className: "[--color-icon-secondary:#000] dark:[--color-icon-secondary:#fff]",
  },
  mention: { icon: "At" },
} satisfies Record<string, { icon: IconName; className?: string }>;

export type NotificationBadgeVariant = keyof typeof BADGE_VARIANTS;

export function NotificationBadge({ variant }: { variant: NotificationBadgeVariant }) {
  const { icon, className } = BADGE_VARIANTS[variant] as { icon: IconName; className?: string };
  return (
    <span
      aria-hidden
      className={twMerge(
        "flex h-[22px] w-[22px] shrink-0 items-center justify-center overflow-hidden rounded-full bg-white [--color-icon-main:#000] dark:bg-gray-900 dark:[--color-icon-main:#fff]",
        className,
      )}
    >
      <Icon name={icon} width={16} height={16} strokeWidth={1.5} className="shrink-0" />
    </span>
  );
}
